module.exports = __webpack_public_path__ + "img/1542858289.8b9d1b0c.jpg";